import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { cn } from 'ui/lib/utils';
import { useContentHeight } from '../../hooks/useContentHeight.js';
const SideBarContext = createContext({});
export const SideBar = ({ useTailwindPrefix, position = 'left', isVisible, onClose, children, containerClassName, className, autoHeight, }) => {
    const [visible, setVisible] = useState(isVisible);
    const containerRef = useRef(null);
    const { isContentTallerThanViewport, contentRef: sidebarRef } = useContentHeight(visible);
    const didMountRef = useRef(false);
    function hideSidebar(event) {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
            onClose();
        }
    }
    useEffect(() => {
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);
    useEffect(() => {
        var _a;
        if (isVisible) {
            setTimeout(() => {
                setVisible(true);
            }, 100);
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('display', 'flex');
            document.body.style.overflow = 'hidden';
            didMountRef.current = true;
        }
        else if (didMountRef.current && !isVisible) {
            setVisible(false);
            document.body.style.overflow = 'unset';
            setTimeout(() => {
                var _a;
                (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('display', 'none');
            }, 300);
        }
    }, [isVisible]);
    return (_jsx(SideBarContext.Provider, Object.assign({ value: { useTailwindPrefix, onClose } }, { children: _jsx("div", Object.assign({ className: classNames(containerClassName, {
                'fixed top-0 left-0 h-full w-full cursor-pointer hidden overflow-y-auto': !useTailwindPrefix,
                'tw-fixed tw-top-0 tw-left-0 tw-h-full tw-w-full tw-cursor-pointer tw-hidden tw-overflow-y-auto': useTailwindPrefix,
                'items-start': isContentTallerThanViewport && !useTailwindPrefix,
                'tw-items-start': isContentTallerThanViewport && useTailwindPrefix,
                'items-center': !isContentTallerThanViewport && !useTailwindPrefix,
                'tw-items-center': !isContentTallerThanViewport && useTailwindPrefix,
                'justify-end': position === 'right' && !useTailwindPrefix,
                'tw-justify-end': position === 'right' && useTailwindPrefix,
            }), onClick: hideSidebar, ref: containerRef }, { children: _jsx("div", Object.assign({ className: cn({
                    'w-1/3 shadow-lg transition cursor-auto ease-in': !useTailwindPrefix,
                    'tw-w-1/3 tw-shadow-lg tw-transition tw-cursor-auto tw-ease-in': useTailwindPrefix,
                    'h-full': !autoHeight && !useTailwindPrefix,
                    'tw-h-full': !autoHeight && useTailwindPrefix,
                    'h-auto my-4': autoHeight && !useTailwindPrefix,
                    'tw-h-auto tw-my-4': autoHeight && useTailwindPrefix,
                    'translate-x-0 opacity-100': visible && !useTailwindPrefix,
                    'tw-translate-x-0 tw-opacity-100': visible && useTailwindPrefix,
                    '-translate-x-full opacity-0': !visible && position === 'left' && !useTailwindPrefix,
                    'tw--translate-x-full tw-opacity-0': !visible && position === 'left' && useTailwindPrefix,
                    'translate-x-full opacity-0': !visible && position === 'right' && !useTailwindPrefix,
                    'tw-translate-x-full tw-opacity-0': !visible && position === 'right' && useTailwindPrefix,
                }, className), ref: sidebarRef }, { children: children })) })) })));
};
const CloseButton = ({ className }) => {
    const { useTailwindPrefix, onClose } = useContext(SideBarContext);
    function onCloseEvent() {
        if (onClose) {
            onClose();
        }
    }
    return (_jsx("div", Object.assign({ className: classNames(className, {
            'absolute top-0 right-0 z-10 w-8 h-8 rounded-full flex items-center justify-center transition cursor-pointer': !useTailwindPrefix,
            'tw-absolute tw-top-0 tw-right-0 tw-z-10 tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-transition tw-cursor-pointer': useTailwindPrefix,
        }), onClick: onCloseEvent }, { children: _jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960", className: classNames({ 'h-6 w-6': !useTailwindPrefix, 'tw-h-6 tw-w-6': useTailwindPrefix }), fill: "currentColor" }, { children: _jsx("path", { d: "m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" }) })) })));
};
SideBar.CloseButton = CloseButton;
export default SideBar;
